import { render, staticRenderFns } from "./DepositsVsSales.vue?vue&type=template&id=5ffccc31"
import script from "./DepositsVsSales.vue?vue&type=script&lang=js"
export * from "./DepositsVsSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports